import React from "react";
import ReactECharts from "echarts-for-react";
import { Empty } from "antd";
import CenterSpin from "../../misc/spin";

export default function CardGraph({
  options,
  isLoading,
  isDataAvailable,
  country,
  borderRadius,
}) {
 
  function getBorderRadiusClassName(br) {
    let className = "";

    switch (br) {
      case "right":
        className = "round-corners-right";
        break;
      case "left":
        className = "round-corners-left";
        break;
      case "all":
        className = "round-corners-all";
        break;
      default:
    }

    return className;
  }
  return (
    <div className="card-graph">
      {options && !isLoading ? (
        isDataAvailable ? (
          <ReactECharts
            option={options}
            className={getBorderRadiusClassName(borderRadius)}
            style={{ height: "100%", width: "100%" }}
          />
        ) : (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Empty
              style={{ width: "100%" }}
              description={
                <span style={{ fontSize: "24px" }}>
                  Sin datos para {country}
                </span>
              }
            />
          </div>
        )
      ) : (
        <CenterSpin />
      )}
    </div>
  );
}
